// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
// Dialog wrapper for the contact data CSV import workflow.
// Provides a full-width dialog containing the multi-step upload component.
import { ContactDataUpload } from '@/contact/components/contact-data-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Full-width dialog for importing contact data from a CSV file.
 *
 * @param props.isOpen - Whether the dialog is currently visible
 * @param props.onClose - Callback to close the dialog
 */
export function ContactDataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Upload contact data</DialogTitle>
      <DialogContent dividers>
        <ContactDataUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
